import { createLogger as _createLogger } from "@jesus-central-church/logger";
import { name } from "../../package.json";

export const createLogger = () => {
  return _createLogger(name);
};
